import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/z',
    name: 'home',
    component: () => import('@/views/index/index.vue')
  },
  {
    path: '/',
    redirect: '/z'  // 将根路径重定向到/home
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
